import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    objectFit: 'cover'
  },
  changeCameraWrapper: {
    cursor: 'pointer',
    position: 'absolute',
    right: 0,
    bottom: 0,
    [theme.breakpoints.down('md')]: {
      right: '2%',
      bottom: '2%',
    },
  },
  changeCameraBtn: {
    minWidth: 30,
    padding: 20,
    boxShadow: 'none',
    zIndex: 1,
    [theme.breakpoints.down('md')]: {
      padding: 10
    },
  },
  changeCameraIcon: {
    width: 30,
    height: 30
  }
}));
